import {ItemModelType, WorkspaceModelType} from "../../stores/WorkspaceStore";

export const _apply_affected_items = async (
    workspace: WorkspaceModelType,
    targetItem: ItemModelType,
    applyToExclusiveChilds: (item: ItemModelType) => Promise<void>,
    applyToNonExclusiveChilds?: (item: ItemModelType) => Promise<void>,
    applyToParents?: (item: ItemModelType) => Promise<void>
) => {
    const allDoneTasks: Promise<any>[] = [];
    for (const item of workspace.items.values()) {
        if (item.childIds.indexOf(targetItem.id) !== -1) {
            applyToParents && allDoneTasks.push(applyToParents(item));
        }
        if (targetItem.childIds.indexOf(item.id) !== -1) {
            if (hasNonDeletedParents(item, workspace, targetItem.id)) {
                applyToNonExclusiveChilds && allDoneTasks.push(applyToNonExclusiveChilds(item));
            } else {
                allDoneTasks.push(applyToExclusiveChilds(item));
            }
        }
    }
    return Promise.all(allDoneTasks);
}

const hasNonDeletedParents = (
    item: ItemModelType,
    workspace: WorkspaceModelType,
    excludeParent: string
) => {
    if (workspace.childIds.indexOf(item.id) !== -1) {
        return true;
    }

    for (const potentialParentItem of workspace.items.values()) {
        if (potentialParentItem.id === excludeParent || potentialParentItem.trashed) {
            continue;
        }

        if (potentialParentItem.childIds.includes(item.id)) {
            return true;
        }
    }

    return false;
}
